<div class="getPathContainer">
    <div class="moveContainer" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle></div>
    <div style="display: flex; flex-direction: row; justify-content: space-between;">
        <div>
            <h1>Get Encompass Path</h1>
        </div>
        <div>
            <h1>
                <i class="material-icons noselect" (click)="closeDialog()">
          close
        </i>
            </h1>
        </div>
    </div>
    <div class="content-container">
        <div class="row1">
            <mat-form-field class="field1">
                <input matInput placeholder="Field Name" [(ngModel)]="fieldName" (keydown.enter)="getEncompassPath()">
            </mat-form-field>
        </div>
    </div>
    <div class="btn-container">
        <button class="cancelBtn" mat-stroked-button (click)="closeDialog()">Cancel</button>
        <button class="get-path-Btn " color="accent" mat-raised-button (click)="getEncompassPath()">Get Path
    </button>
    </div>

    <div class="spinner-container" *ngIf="showSpinner">
        <div class="new-spinner">
            <div class="outer-ring"></div>
            <div class="middle-ring"></div>
            <div class="inner-ring"></div>
        </div>
    </div>
</div>
